import { all, takeLatest, put } from 'redux-saga/effects';

import { toggleSignupTutorialDialog } from '@coconut/services/redux/signupDialog';
import { types } from '@coconut/services/redux/questionListTutorial';

function* skipTutorialFlow() {
  yield put(toggleSignupTutorialDialog());
}

function* skipTutorialTutorProfileInListFlow() {
  yield put(toggleSignupTutorialDialog());
}

export default function* () {
  yield all([
    takeLatest(types.SKIP_TUTORIAL, skipTutorialFlow),
    takeLatest(
      types.SKIP_TUTORIAL_TUTOR_PROFILE_IN_QUESTION_LIST,
      skipTutorialTutorProfileInListFlow
    ),
  ]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/questionListTutorial.js